<template>
  <div id="zhoushuju">
    <!--日期-->
    <p class="ca flex-box relativeItem">
      <a class="allA" @click="open_ca"></a>
      <img src="../../assets/shdi(2).png" class="noevents-img caimg" />
      {{ week_data.week }}
      <img
        src="../../assets/live/zhibo.png"
        class="absoluteItem arrowimg"
      />
    </p>

    <!--图表-->
    <div class="tubiao">
      <ve-line
        :data="chartData"
        :tooltip-visible="false"
        :legend-visible="false"
        :extend="extend"
        :colors="barColors"
        height="170px"
      ></ve-line>
      <ve-line
        :data="s_chartData"
        :tooltip-visible="false"
        :legend-visible="false"
        :extend="s_extend"
        :colors="s_barColors"
        height="170px"
      ></ve-line>
      <p class="flex-box biaoji">
        <img src="../../assets/live/zhibo(1).png" class="zhenzhu noevents-img" />
        珍珠数(个)
        <img src="../../assets/live/zhibo(2).png" class="shijian noevents-img" />
        直播时长(分钟)
      </p>
    </div>

    <!--数量统计-->
    <div class="number">
      <!--珍珠-->
      <div class="zhenzhunumber flex-box">
        <div>
          本周获得珍珠总数(个)
          <span>{{ week_data.total_pearl }}</span>
        </div>
        <div>
          平均获得珍珠数(个)
          <span>{{ week_data.average_pearl }}</span>
        </div>
      </div>
      <!--时间场次-->
      <div class="shijiannumber flex-box">
        <div>
          本周直播场次
          <span>{{ week_data.live_number }}</span>
        </div>
        <div>
          平均直播时间
          <span>{{ week_data.average }}</span>
        </div>
        <div>
          新增粉丝
          <span>{{ week_data.add_fans }}</span>
        </div>
      </div>
    </div>

    <!--贡献榜单-->
    <div class="gongxian" v-show="user_list.length > 0">
      <p class="title">用户贡献榜</p>
      <!--明细列表-->
      <ul class="zhenzhulist">
        <li class="flex-box" v-for="(n, index) in user_list" :key="index">
          <div class="flex-box">
            <img class="noevents-img" :src="n.img" />
            <span class="apostrophe">{{ n.nickname }}</span>
          </div>
          <div>{{ n.pearl }}</div>
        </li>
      </ul>
    </div>

    <!--送礼人数-->
    <div class="zhenzhunumber songli flex-box">
      <div>
        本周送礼人数
        <span>{{ week_data.week_the_number_of_gift_giving }}</span>
      </div>
      <div>
        本周观看人数
        <span>{{ week_data.week_watch_number_of_people }}</span>
      </div>
    </div>

    <!--观众流失-->
    <div class="liushi">
      <div class="title">观众流失</div>
      <p class="relativeItem">
        本周取关人数
        <span class="absoluteItem centerY">{{ week_data.cancelFav }}</span>
      </p>
    </div>

    <!--空表组件-->
    <blank message="今日暂无直播数据" v-if="showBlank" class="blank" />

    <!--日期选择器-->
    <calendar
      v-model="show_ca"
      @select="onSelect"
      @confirm="onConfirm"
      :min-date="minDate"
      :default-date="defaultDate"
      type="range"
      :max-range="7"
      color="#FF6161"
    />
  </div>
</template>














<script>
import blank from "../me/blank";
import Calendar from "vant/lib/calendar";
import "vant/lib/calendar/style";

export default {
  name: "zhoushuju",
  components: {
    blank,
    Calendar
  },
  data() {
    this.extend = {
      series: {
        label: {
          normal: {
            show: true,
            color: "#666"
          }
        },
        smooth: false,
        symbolSize: 8
      },
      yAxis: {
        show: false // 隐藏坐标轴
      },
      xAxis: {
        show: false,
        axisLabel: {
          interval: 0
        }
      },
      grid: {
        top: "12%",
        bottom: "10%",
        left: "-16"
      }
    };
    this.s_extend = {
      series: {
        label: {
          normal: {
            show: true,
            color: "#666"
          }
        },
        smooth: false,
        symbolSize: 8
      },
      yAxis: {
        show: false // 隐藏坐标轴
      },
      xAxis: {
        axisLabel: {
          color: "#999"
        }
      },
      grid: {
        top: "12%",
        bottom: "10%",
        left: "-16"
      }
    };
    return {
      showBlank: false,
      show_ca: false, //是否展示日历
      defaultDate: [new Date(2020, 2, 31)],
      minDate: new Date(2018, 1, 1),
      maxDate: new Date(2020, 2, 31),
      week_data: [], //周直播数据
      user_list: [], //贡献列表
      barColors: ["#FDA62A"],
      chartData: {
        columns: ["日期", "珍珠数(个)"],
        rows: [
          { 日期: "周一", "珍珠数(个)": 0 },
          { 日期: "周二", "珍珠数(个)": 0 },
          { 日期: "周三", "珍珠数(个)": 0 },
          { 日期: "周四", "珍珠数(个)": 0 },
          { 日期: "周五", "珍珠数(个)": 0 },
          { 日期: "周六", "珍珠数(个)": 0 },
          { 日期: "周日", "珍珠数(个)": 0 }
        ]
      },
      s_barColors: ["#BD4FFF"],
      s_chartData: {
        columns: ["日期", "直播时长(分钟)"],
        rows: [
          { 日期: "周一", "直播时长(分钟)": 0 },
          { 日期: "周二", "直播时长(分钟)": 0 },
          { 日期: "周三", "直播时长(分钟)": 0 },
          { 日期: "周四", "直播时长(分钟)": 0 },
          { 日期: "周五", "直播时长(分钟)": 0 },
          { 日期: "周六", "直播时长(分钟)": 0 },
          { 日期: "周日", "直播时长(分钟)": 0 }
        ]
      }
    };
  },
  methods: {
    /**打开日历 */
    open_ca() {
      this.show_ca = true;
    },

    /**时间选择确认 */
    formatDate(date) {
      return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      this.show_ca = false;
      this.getData(parseInt(date[0].getTime() / 1000));
    },
    onSelect(date) {
      this.defaultDate = this.get_week_star_end(date[0]);
    },

    /**获取任意周的开始和结束时间 */
    get_week_star_end(today) {
      let oToday = today || new Date();
      let currentDay = oToday.getDay();
      if (currentDay == 0) {
        currentDay = 7;
      }
      let mondayTime =
        oToday.getTime() - (currentDay - 1) * 24 * 60 * 60 * 1000;
      let sundayTime =
        oToday.getTime() + (7 - currentDay) * 24 * 60 * 60 * 1000;
      return [new Date(mondayTime), new Date(sundayTime)];
    },
    /**获取当前一周 */
    get_time() {
      this.defaultDate = this.get_week_star_end();
      this.getData(parseInt(this.defaultDate[0].getTime() / 1000));
    },

    //获取数据
    getData(time) {
      let _this = this;
      let data = {
        time: time
      };
      this.$jsonp(this.$apis("zhouzhibo"), data, res => {
        _this.week_data = res.data.data;
        _this.user_list = res.data.data.userList;
        if (res.data.data.weekList.length > 0) {
          for (let i = 0; i < res.data.data.weekList.length; i++) {
            _this.chartData.rows[i]["珍珠数(个)"] =
              res.data.data.weekList[i].pearl;
            _this.s_chartData.rows[i]["直播时长(分钟)"] =
              res.data.data.weekList[i].hour;
          }
        } else {
          _this.chartData.rows.forEach(e => {
            e["珍珠数(个)"] = 0;
          });
          _this.s_chartData.rows.forEach(e => {
            e["直播时长(分钟)"] = 0;
          });
        }
      });
    }
  },
  mounted() {
    this.get_time();
    this.get_week_star_end();
  }
};
</script>















<style scoped>
.allA {
  z-index: 2;
}
.blank {
  margin-top: 50%;
}
/**日历 */
.ca {
  font-size: 15px;
  background: #f0f0f0;
  align-items: center;
  padding: 13px 16px;
}
.ca .caimg {
  width: 22px;
  height: 22px;
  margin-right: 8px;
}
.ca .arrowimg {
  width: 18px;
  right: 16px;
  top: 50%;
  transform-origin: center center;
  transform: translateY(-50%) rotateZ(-90deg);
}

/**图表 */
.tubiao .biaoji {
  align-items: center;
  font-size: 12px;
  padding: 14px 16px;
}
.tubiao .biaoji img {
  width: 22px;
  height: 8px;
  margin-right: 12px;
}
.tubiao .biaoji .shijian {
  margin-left: 27%;
}

/**数量统计 */
.zhenzhunumber {
  position: relative;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  color: #999;
  text-align: center;
  margin-top: 16px;
}
.zhenzhunumber::after,
.zhenzhunumber::before {
  position: absolute;
  content: "";
  background: #f0f0f0;
}
.zhenzhunumber::before {
  height: 1px;
  width: 93%;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
}
.zhenzhunumber::after {
  width: 1px;
  height: 45%;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}

.zhenzhunumber div {
  width: 50%;
}
.zhenzhunumber span {
  display: block;
  font-size: 27px;
  color: #333;
  margin-top: 15px;
  margin-bottom: 18px;
}
.songli span {
  margin-top: 2px;
  margin-bottom: 10px;
}
.songli::before {
  height: 1px;
  width: 100%;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
}

.shijiannumber {
  font-size: 12px;
  color: #999;
  text-align: center;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  margin-top: 5px;
}
.shijiannumber div {
  width: 33%;
}
.shijiannumber div:nth-child(2) {
  width: 34%;
  position: relative;
}
.shijiannumber div:nth-child(2)::before,
.shijiannumber div:nth-child(2)::after {
  position: absolute;
  content: "";
  width: 1px;
  background: #f0f0f0;
  height: 50%;
}
.shijiannumber div:nth-child(2)::before {
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.shijiannumber div:nth-child(2)::after {
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.shijiannumber span {
  display: block;
  font-size: 22px;
  color: #333;
  margin-top: 2px;
  margin-bottom: 8px;
}

/**贡献榜 */
.title {
  text-align: center;
  padding: 16px 0;
  font-size: 13px;
  color: #666;
}
/**珍珠list */
.zhenzhulist {
  align-items: center;
  font-size: 15px;
  color: #999;
  background: #fafafa;
  transition: all 1s;
  height: 177px;
  overflow-y: scroll;
}
.zhenzhulist li {
  justify-content: space-between;
  align-items: center;
  padding: 13px 16px;
}
.zhenzhulist div {
  align-items: center;
}
.zhenzhulist span {
  max-width: 100px;
}
.zhenzhulist img {
  border-radius: 50%;
  margin-right: 12px;
  width: 33px;
  height: 33px;
}

/**观众流失 */
.liushi {
  padding-bottom: 40px;
}
.liushi p {
  padding: 0 16px;
  font-size: 15px;
  color: #999;
}
.liushi span {
  right: 16px;
  font-size: 27px;
  color: #333;
}
</style>

